import { type PropsWithChildren, useState } from 'react';
import { AnnouncementEndpoints } from '@/api/endpoints/AnnouncementEndpoints';
import { AnnouncementStatus } from '@/app/enums/AnnouncementStatus';
import { type AnnouncementRecipientDto } from '@/app/models/AnnouncementRecipientDto';
import { type DataTableColumnDef } from '@/app/models/DataTableColumnDef';
import { RECEIVED_ANNOUNCEMENTS_TABLE_KEY } from '@/app/modules/announcements/core/_consts';
import AnnouncementModal from '@/app/modules/announcements/components/AnnouncementModal';
import { DataTable } from '@/app/modules/table/DataTable';
import DataTableBody from '@/app/modules/table/components/DataTableBody';
import DataTableControls from '@/app/modules/table/components/DataTableControls';
import DataTablePagination from '@/app/modules/table/components/DataTablePagination';
import AnnouncementListFilter from '@/app/pages/notifications/announcements/components/AnnouncementListFilter';
import { receivedAnnouncementColumns } from '@/app/pages/notifications/announcements/core/_columns';
import { ANNOUNCEMENT_STATUS_OPTIONS } from '@/app/pages/notifications/announcements/core/_consts';
import { type AnnouncementStatusOption } from '@/app/pages/notifications/announcements/core/_models';

// Quem recebe nunca vê rascunho.
const RECEIVED_STATUS_OPTIONS: AnnouncementStatusOption[] = ANNOUNCEMENT_STATUS_OPTIONS.filter(
  (option) => option.value !== AnnouncementStatus.DRAFT,
);

const ReceivedAnnouncementsTab = ({ children }: PropsWithChildren) => {
  const [openAnnouncement, setOpenAnnouncement] = useState<AnnouncementRecipientDto>();

  return (
    <>
      {openAnnouncement ? (
        <AnnouncementModal
          key={openAnnouncement.id}
          announcement={openAnnouncement}
          onClose={() => setOpenAnnouncement(undefined)}
        />
      ) : null}
      <DataTable
        columns={receivedAnnouncementColumns as DataTableColumnDef<object>[]}
        direction="desc"
        endpoint={AnnouncementEndpoints.myList}
        filterComponents={[<AnnouncementListFilter key="filters" statusOptions={RECEIVED_STATUS_OPTIONS} />]}
        isRefreshable={true}
        searchPlaceHolder="Pesquise pelo título"
        sort="published_date"
        tableKey={RECEIVED_ANNOUNCEMENTS_TABLE_KEY}
        variant="list"
        onRowClick={(row) => setOpenAnnouncement(row.original as AnnouncementRecipientDto)}
      >
        <DataTableControls />
        {children}
        <DataTableBody showHeader={true} />
        <DataTablePagination />
      </DataTable>
    </>
  );
};

export default ReceivedAnnouncementsTab;
